import { Routes } from '@angular/router';
import { portalRoutes } from './portal/portal.routes';
import { guestGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'auth/landing', pathMatch: 'full' },
  {
    path: 'auth',
    children: [
      {
        path: 'landing',
        canActivate: [guestGuard],
        loadComponent: () =>
          import('./auth/landing-page/landing-page.component').then(
            (m) => m.LandingPageComponent,
          ),
      },
      {
        path: 'login',
        canActivate: [guestGuard],
        loadComponent: () =>
          import('./auth/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'register',
        canActivate: [guestGuard],
        loadComponent: () =>
          import('./auth/register/register.component').then(
            (m) => m.RegisterComponent,
          ),
      },
      // 2FA deferred — re-enable when OTP verification is implemented
      // {
      //   path: 'verify-otp',
      //   loadComponent: () =>
      //     import('./auth/twofa/twofa.component').then((m) => m.TwofaComponent),
      // },
    ],
  },
  { path: 'portal', children: portalRoutes },
  //{ path: '**', redirectTo: 'auth/landing' },
];
